import { Action } from "@reduxjs/toolkit";
import { FeatureState } from "./types";
import { isType } from "typescript-fsa";
import { featureActions } from "./actions";

const initialState: FeatureState = {
  features: null,
};

export function FeatureReducer(
  state = initialState,
  action: Action
): FeatureState {
  if (isType(action, featureActions.fetchFeatures.done)) {
    return {
      ...state,
      features: action.payload.result.map((feature) => ({
        id: feature.id,
        name: feature.name,
        name_kh: feature.name_kh,
        name_zh: feature.name_zh,
      })),
    };
  }

  if (isType(action, featureActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
